<template>
  <AppModal
    v-if="currentSearch"
    :mode="mode"
    title="Edit Search"
    @close="$emit('closeEditSearch')"
  >
    <template #body>
      <div class="grid gap-4">
        <AppInput
          :mode="mode"
          id="name"
          title="Name"
          placeholder="Name"
          v-model="currentSearch.search_name"
        />
        <AppInput
          :mode="mode"
          id="days-to-search"
          type="number"
          title="Days to search"
          min="0"
          placeholder="Days to search"
          v-model="currentSearch.days_to_search"
        />
        <AppInput
          :mode="mode"
          id="query"
          title="Query"
          placeholder="Query"
          v-model="currentSearch.query"
        />
        <div class="flex justify-center">
          <AppButton title="Update" @action="updateSearch" />
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import AppInput from "@C/Form/AppInput.vue";
import AppModal from "@C/Common/AppModal.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "EditSearch",
  props: {
    mode: String,
    currentSearch: {
      type: Object,
      default: {},
    },
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      handleError,
    };
  },
  components: {
    AppModal,
    AppInput,
    AppButton,
  },
  methods: {
    async updateSearch() {
      this.loaderStore.setIsLoading(true);
      const payload = {
        contact_search: {
          contact_id: this.currentSearch.contact_id,
          contact_search_id: this.currentSearch.contact_search_id,
          days_to_search: this.currentSearch.days_to_search,
          is_daily_summary: false,
          is_data_feed: false,
          last_sent: "",
          query: this.currentSearch.query,
          search_name: this.currentSearch.search_name,
          send_time_hr: 18,
          send_time_min: 0,
        },
      };
      try {
        const { data } = await ApiRequest().post(`/contact_searches`, payload);
        if (data) {
          this.toastStore.show("Search updated successfully!", "success");
          this.$emit("searchUpdated");
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
};
</script>
